import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot, Routes } from '@angular/router';
import { LotPopupComponent } from './lot-dialog.component';
import { LotDeletePopupComponent } from './lot-delete-dialog.component';
import { LotCreatePopupComponent } from './lot-create-dialog.component';
import { LotImportPopupComponent } from './lot-import-dialog.component';
import { DEPOSIT_INVENTORY, MANAGE_LOT_PERMISSIONS, UPDATE_LOT_BALANCE_PERMISSIONS, WITHDRAW_INVENTORY } from '../../shared/auth/permissions';
import { LotWithdrawalPopupComponent } from './lot-withdrawal-dialog.component';
import { LotUpdatePopupComponent } from './lot-update-dialog.component';
import { LotDepositPopupComponent } from './lot-deposit-dialog.component';
import { LotBalanceAdjustmentPopupComponent } from './lot-balance-adjustment-dialog.component';
import { LotImportDepositPopupComponent } from './lot-import-deposit-dialog.component';
import { LotImportUpdatePopupComponent } from './lot-import-update-dialog.component';
import { LotMergePopupComponent } from './lot-merge-dialog.component';
import { LotSplitPopupComponent } from './lot-split-dialog.component';
import { LotImportUpdateBalancePopupComponent } from './lot-import-update-balance-dialog.component';
import { JhiPaginationUtil } from '../../shared/core-utils';
import { RouteAccessService } from '../../shared';

@Injectable()
export class LotResolvePagingParams implements Resolve<any> {

    constructor(private paginationUtil: JhiPaginationUtil) {
    }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const page = route.queryParams['page'] ? route.queryParams['page'] : '1';
        const sort = route.queryParams['sort'] ? route.queryParams['sort'] : 'lotId,asc';
        return {
            page: this.paginationUtil.parsePage(page),
            predicate: this.paginationUtil.parsePredicate(sort),
            ascending: this.paginationUtil.parseAscending(sort)
        };
    }
}

export const LOT_ROUTES: Routes = [
    {
        path: '',
        redirectTo: 'lot',
        pathMatch: 'full'
    }
];

export const LOT_POPUP_ROUTES: Routes = [
    {
        path: 'lot-withdrawal',
        component: LotWithdrawalPopupComponent,
        data: {
            pageTitle: 'inventoryManagerApp.lot.home.title',
            authorities: [...MANAGE_LOT_PERMISSIONS, ...WITHDRAW_INVENTORY]
        },
        canActivate: [RouteAccessService],
        outlet: 'popup'
    },
    {
        path: 'lot-import',
        component: LotImportPopupComponent,
        data: {
            pageTitle: 'inventoryManagerApp.lot.home.title',
            authorities: [...MANAGE_LOT_PERMISSIONS, 'IMPORT_LOTS']
        },
        canActivate: [RouteAccessService],
        outlet: 'popup'
    },
    {
        path: 'lot-import-updates',
        component: LotImportUpdatePopupComponent,
        data: {
            pageTitle: 'inventoryManagerApp.lot.home.title',
            authorities: [...MANAGE_LOT_PERMISSIONS, 'IMPORT_LOTS']
        },
        canActivate: [RouteAccessService],
        outlet: 'popup'
    },
    {
        path: 'lot-import-update-balance',
        component: LotImportUpdateBalancePopupComponent,
        data: {
            pageTitle: 'inventoryManagerApp.lot.home.title',
            authorities: [...MANAGE_LOT_PERMISSIONS, 'UPDATE_LOTS']
        },
        canActivate: [RouteAccessService],
        outlet: 'popup'
    },
    {
        path: 'lot-new',
        component: LotCreatePopupComponent,
        data: {
            pageTitle: 'inventoryManagerApp.lot.home.title',
            authorities: [...MANAGE_LOT_PERMISSIONS, 'CREATE_LOTS']
        },
        canActivate: [RouteAccessService],
        outlet: 'popup'
    },
    {
        path: 'lot-update',
        component: LotUpdatePopupComponent,
        data: {
            pageTitle: 'inventoryManagerApp.lot.update.title',
            authorities: [...MANAGE_LOT_PERMISSIONS, 'UPDATE_LOTS']
        },
        canActivate: [RouteAccessService],
        outlet: 'popup'
    },
    {
        path: 'lot-deposit',
        component: LotDepositPopupComponent,
        data: {
            pageTitle: 'inventoryManagerApp.lot.home.title',
            authorities: [...MANAGE_LOT_PERMISSIONS, ...DEPOSIT_INVENTORY]
        },
        canActivate: [RouteAccessService],
        outlet: 'popup'
    },
    {
        path: 'lot/:lotId/edit',
        component: LotPopupComponent,
        data: {
            pageTitle: 'inventoryManagerApp.lot.home.title'
        },
        outlet: 'popup'
    },
    {
        path: 'lot/:lotId/delete',
        component: LotDeletePopupComponent,
        data: {
            pageTitle: 'inventoryManagerApp.lot.home.title'
        },
        outlet: 'popup'
    },
    {
        path: 'lot-balance-adjustment',
        component: LotBalanceAdjustmentPopupComponent,
        data: {
            pageTitle: 'inventoryManagerApp.lot.home.title',
            authorities: [...UPDATE_LOT_BALANCE_PERMISSIONS]
        },
        canActivate: [RouteAccessService],
        outlet: 'popup'
    },
    {
        path: 'lot-import-deposit',
        component: LotImportDepositPopupComponent,
        data: {
            pageTitle: 'inventoryManagerApp.lot.home.title',
            authorities: [...MANAGE_LOT_PERMISSIONS, ...DEPOSIT_INVENTORY]
        },
        canActivate: [RouteAccessService],
        outlet: 'popup'
    },
    {
        path: 'lot-merge',
        component: LotMergePopupComponent,
        data: {
            pageTitle: 'inventoryManagerApp.lot.home.title',
            authorities: [...MANAGE_LOT_PERMISSIONS, 'MERGE_LOTS']
        },
        canActivate: [RouteAccessService],
        outlet: 'popup'
    },
    {
        path: 'lot-split',
        component: LotSplitPopupComponent,
        data: {
            pageTitle: 'inventoryManagerApp.lot.home.title',
            authorities: [...MANAGE_LOT_PERMISSIONS, 'SPLIT_LOT']
        },
        canActivate: [RouteAccessService],
        outlet: 'popup'
    }
];
